module.exports = __webpack_public_path__ + "static/img/paysteps2@3x.cc0ba3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paysteps2@3x.png
// module id = oedW
// module chunks = 1